import {Directive, ElementRef, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {I18nService} from "../../i18n/i18n.service";

declare let $: any;
let moment = require('moment');

@Directive({
    selector: '[uiDateTimepicker]'
})
export class UiDateTimepickerDirective implements OnInit {

    @Input() uiDateTimepicker: any;
    @Output() change: EventEmitter<string> = new EventEmitter();

    constructor(private el: ElementRef,
                private i18n: I18nService) {
    }

    ngOnInit() {
        System.import("script-loader!assets/external-js/bootstrap-datetimepicker.js").then(() => {
            if (this.i18n.currentLanguage.key.toLowerCase() !== "en") {
                this.uiDateTimepicker.language = this.i18n.currentLanguage.key.toLowerCase();
                $.getScript("assets/external-js/locales/bootstrap-datetimepicker." + this.uiDateTimepicker.language + ".js", () => this.render());
            } else {
                this.render();
            }

        });
    }

    render() {
        let onSelectCallbacks = [];
        let uiDateTimepicker = this.uiDateTimepicker || {};
        let element = $(this.el.nativeElement);

        element.attr("readonly", "readonly");
        element.attr("autocomplete", "off");
        //Let others know about changes to the data field
        onSelectCallbacks.push((selectedDate) => {
            element.triggerHandler("change");

            let form = element.closest('form');

            if (typeof form.bootstrapValidator == 'function') {
                try {
                    form.bootstrapValidator('revalidateField', element);
                } catch (e) {
                    console.error(e.message)
                }
            }
        });

        let startDate: Date = moment(element.val()).toDate();

        let options = $.extend(uiDateTimepicker, {
            autoclose: true,
            startDate: (!!startDate && startDate < new Date()) ? startDate : new Date(),
            fontAwesome: true
        });

        element.datetimepicker(options)
            .on("changeDate", (selectedDate) => {
                this.change.emit(selectedDate);
                onSelectCallbacks.forEach((callback) => {
                    callback.call(callback, selectedDate.date.valueOf())
                })
            });
    }
}